import React, { useState } from "react";
import "./ReviewSlider.scss";
import arrow from "../../assets/icons/arrow-green.svg"
import star from "../../assets/icons/star.svg"


const ReviewSlider = ({ items }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const itemsPerSlide = 3;

    const totalSlides = Math.ceil(items.length / itemsPerSlide);

    const nextSlide = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex < totalSlides - 1 ? prevIndex + 1 : 0
        );
    };

    const prevSlide = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex > 0 ? prevIndex - 1 : totalSlides - 1
        );
    };

    const getVisibleItems = () => {
        const start = currentIndex * itemsPerSlide;
        return items.slice(start, start + itemsPerSlide);
    };

    return (
        <div className="ReviewSlider">
            <div className="ReviewSlider-container">
                <div className="arrow left" onClick={prevSlide}>
                    <img alt="" src={arrow} />
                </div>

                <div className="ReviewSlider-slides">
                    {getVisibleItems().map((item, idx) => (
                        <div className="ReviewSlider-item" key={idx}>
                            <div className="ReviewSlider-item-cont">
                                <div className="ReviewSlider-item-name">
                                    {item?.name}
                                </div>
                                <div className="ReviewSlider-rate">
                                    {[...Array(item?.rate)].map((_, key) => {
                                        return (
                                            <img alt="" src={star} key={key} />
                                        )
                                    })}
                                </div>
                                <div className="ReviewSlider-item-review">
                                    {item?.review}
                                </div>
                            </div>
                            <img alt="" src={item?.image}
                                className="ReviewSlider-item-avatar" />
                        </div>
                    ))}
                </div>

                <div className="arrow right" onClick={nextSlide}>
                    <img alt="" src={arrow} />
                </div>
            </div>
            <div className="ReviewSlider-dots">
                {Array.from({ length: totalSlides }).map((_, idx) => (
                    <span
                        key={idx}
                        className={`dot ${currentIndex === idx ? "active" : ""}`}
                        onClick={() => setCurrentIndex(idx)}
                    />
                ))}
            </div>
        </div>

    );
};

export default ReviewSlider;
